// Carry Roll Sensitivity analysis — finite-difference derivatives per input (7.7). Pure.
import { simulate } from './simulate';
import { degToRad } from './units';
/**
 * Per-input distance sensitivities via central finite-difference.
 * Returns sorted list of sensitivities (m carry per unit input change).
 */
export function sensitivity(request) {
    const baseline = simulate(request).carryM;
    const results = [];
    const perturb = (parameter, unit, applyFn, h) => {
        const up = simulate(applyFn(request, h)).carryM;
        const down = simulate(applyFn(request, -h)).carryM;
        const dCarry = (up - down) / (2 * h);
        const percentChange = baseline > 0 ? (dCarry / baseline) * h * 100 : 0;
        results.push({
            parameter,
            unit,
            dCarryPerUnit: Math.round(dCarry * 100) / 100,
            percentChange: Math.round(percentChange * 100) / 100,
        });
    };
    perturb('Ball speed', 'm/s', (req, d) => ({ ...req, launch: { ...req.launch, ballSpeed: req.launch.ballSpeed + d } }), 1);
    perturb('Launch angle', '°', (req, d) => ({ ...req, launch: { ...req.launch, launchAngle: req.launch.launchAngle + degToRad(d) } }), 1);
    perturb('Spin rate', 'rpm', (req, d) => ({ ...req, launch: { ...req.launch, spinRpm: Math.max(0, req.launch.spinRpm + d) } }), 100);
    perturb('Altitude', 'm', (req, d) => ({ ...req, environment: { ...req.environment, altitudeM: Math.max(0, req.environment.altitudeM + d) } }), 100);
    perturb('Temperature', '°C', (req, d) => ({ ...req, environment: { ...req.environment, temperatureK: req.environment.temperatureK + d } }), 5);
    perturb('Headwind', 'm/s', (req, d) => ({ ...req, environment: { ...req.environment, windSpeed: Math.max(0, req.environment.windSpeed + d) } }), 1);
    results.sort((a, b) => Math.abs(b.dCarryPerUnit) - Math.abs(a.dCarryPerUnit));
    return results;
}
//# sourceMappingURL=sensitivity.js.map